import zod from "zod-i18n-map/locales/ja/zod.json"
import authForm from "./authForm.json"
import baseCustomedForm from "./baseCustomedForm.json"
import questEditor from "./questEditor.json"
import constLabels from "./const.json"

const i18nConfig = {
  translation: {
    "Welcome to React": "翻訳機能が使えるようになりました。",
  },
  authForm: authForm,
  baseCustomedForm: baseCustomedForm,
  questEditor: questEditor,
  const: constLabels,
  zod: zod,
} as const
export default i18nConfig
